export default __webpack_public_path__ + "static/media/9.61a69080.png";